import { render, staticRenderFns } from "./CloseModalIconButton.vue?vue&type=template&id=57634ce9&"
import script from "./CloseModalIconButton.vue?vue&type=script&lang=js&"
export * from "./CloseModalIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports